<template>
    <div class="video-player">
        <div
            id="youtube-player"
            class="video"
        >
        </div>
    </div>
</template>

<script>
    import { loadScript } from '@superbet-group/web.lib.utilities';
    import Vue from 'vue';

    export default Vue.component('YoutubePlayer', {
        props: {
            videoId: {
                type: String,
                required: true,
            },
        },
        async mounted() {
            await this.loadRequirements();
            this.initializeVideoPlayer();
        },
        methods: {
            loadRequirements() {
                return loadScript(
                    'https://www.youtube.com/iframe_api',
                    'youtube',
                );
            },
            async initializeVideoPlayer() {
                // eslint-disable-next-line no-undef
                try {
                    await this.createPlayer();
                } catch {
                    window.onYouTubeIframeAPIReady = this.createPlayer;
                }
            },
            createPlayer() {
                // eslint-disable-next-line no-undef
                return new YT.Player('youtube-player', {
                    videoId: this.videoId,
                    events: {
                        onReady: this.onPlayerReady,
                    },
                    host: 'https://www.youtube.com',
                });
            },
            onPlayerReady(event) {
                event.target.playVideo();
            },
        },
    });
</script>
